<!-- фильтр по параметрам тарифа -->
<template><span style="position: relative">

	<div v-show="showFilter" class="alert alert-info widget-block">
		<div class="widget-filter-wrapper">
			<div class="item" @click.stop="showChoiceBlock">
				<span class="param-title">CPU:</span>
				<span v-if="isCpuEmpty" class="param-value">-</span>
				<span v-else class="param-value">
					<template v-if="valueCpu[0] != valueCpu[1]">{{ valueCpu[0] }} - {{ valueCpu[1] }} {{ params.cpu_min.for | ftc }}</template>
					<template v-else>{{ valueCpu[0] }} {{ params.cpu_min.for | ftc }}</template>
				</span>
			</div>
			<div class="item" @click.stop="showChoiceBlock">
				<span class="param-title">RAM:</span>
				<span v-if="isRamEmpty" class="param-value">-</span>
				<span v-else class="param-value">
					<template v-if="valueRam[0] != valueRam[1]">{{ valueRam[0] }} - {{ valueRam[1] }} {{ params.ram_min.for | ftc }}</template>
					<template v-else>{{ valueRam[0] }} {{ params.ram_min.for | ftc }}</template>
				</span>
			</div>
			<div class="item" @click.stop="showChoiceBlock">
				<span class="param-title">DISK:</span>
				<span v-if="isDiskEmpty" class="param-value">-</span>
				<span v-else class="param-value">
					<template v-if="valueDisk[0] != valueDisk[1]">{{ valueDisk[0] }} - {{ valueDisk[1] }} {{ params.disk_min.for | ftc }}</template>
					<template v-else>{{ valueDisk[0] }} {{ params.disk_min.for | ftc }}</template>
				</span>
			</div>
		</div>
		<button class="btn-close-filter close" @click.stop="$emit('closeDirectlyFilter')">×</button>
	</div>

	<div v-show="showChoicer" class="widget-filter-choicer" ref="choicer">
		<button class="btn-close-filter close" @click.stop="hideChoiceBlock">×</button>

		<!-- CPU -->
		<div class="title">CPU</div>
		<div class="fields-block">
			<div class="field">
				<input type="text" ref="cpu0" :value="sliderValueCpu[0]" @blur="onBlur('cpu', 0)">
			</div>
			<div class="slider">
				<vue-slider v-model="sliderValueCpu"
					ref="slider_cpu"
					tooltip="none"
					:enable-cross="false"
					:min="params.cpu_min.min"
					:max="params.cpu_max.max"
					width="100%">
				</vue-slider>
			</div>
			<div class="field">
				<input type="text" ref="cpu1" :value="sliderValueCpu[1]" @blur="onBlur('cpu', 1)">
			</div>
		</div>

		<div style="height: 20px"></div>

		<!-- RAM -->
		<div class="title">RAM</div>
		<div class="fields-block">
			<div class="field">
				<input type="text" ref="ram0" v-model="sliderValueRam[0]" @blur="onBlur('ram', 0)">
			</div>
			<div class="slider">
				<vue-slider v-model="sliderValueRam"
					ref="slider_ram"
					tooltip="none"
					:enable-cross="false"
					:min="params.ram_min.min"
					:max="params.ram_max.max"
					width="100%">
				</vue-slider>
			</div>
			<div class="field">
				<input type="text" ref="ram1" v-model="sliderValueRam[1]" @blur="onBlur('ram', 1)">
			</div>
		</div>

		<div style="height: 20px"></div>

		<!-- DISK -->
		<div class="title">DISK</div>
		<div class="fields-block">
			<div class="field">
				<input type="text" ref="disk0" v-model="sliderValueDisk[0]" @blur="onBlur('disk', 0)">
			</div>
			<div class="slider">
				<vue-slider v-model="sliderValueDisk"
					ref="slider_disk"
					tooltip="none"
					:enable-cross="false"
					:min="params.disk_min.min"
					:max="params.disk_max.max"
					width="100%">
				</vue-slider>
			</div>
			<div class="field">
				<input type="text" ref="disk1" v-model="sliderValueDisk[1]" @blur="onBlur('disk', 1)">
			</div>
		</div>

		<div style="height: 20px"></div>

		<button
			type="button"
			@click="submit"
			class="btn btn-submut-small btn-primary">
			OK
		</button>
		
	</div>

</span></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import Vue from 'vue'
import numberInput from '@/components/elements/number'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'filterParams',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['name', 'value', 'params', 'visible'],
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		isCpuEmpty() {
			return this.valueCpu[0] === null || this.valueCpu[1] === null
		},
		isRamEmpty() {
			return this.valueRam[0] === null || this.valueRam[1] === null
		},
		isDiskEmpty() {
			return this.valueDisk[0] === null || this.valueDisk[1] === null
		},
		// показывать сам фильтр
		showFilter() {
			// если показан чойсер
			if (this.showChoicer)
			{
				// если уже есть какой то фильр - нужно показывать
				return (!this.isCpuEmpty && !this.isRamEmpty && !this.isDiskEmpty)
			}
			else
			{
				// если уже есть какой то фильр - нужно показывать
				return (!this.isCpuEmpty && !this.isRamEmpty && !this.isDiskEmpty)
			}
		}
	},
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			valueCpu: [null, null],
			valueRam: [null, null],
			valueDisk: [null, null],

			choicerTitle: '',

			sliderValueCpu: [null, null],
			sliderValueRam: [null, null],
			sliderValueDisk: [null, null],

			// показывать выбор
			showChoicer: false
		}
	},
	//=========================================================================
	// событие: компонент создан
	//=========================================================================
	created() {
		this.valueCpu = [this.value.cpu_min, this.value.cpu_max]
		this.valueRam = [this.value.ram_min, this.value.ram_max]
		this.valueDisk = [this.value.disk_min, this.value.disk_max]
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчики
		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickDocumentHandler)

		this.initField('cpu', 0)
		this.initField('cpu', 1)

		this.initField('ram', 0)
		this.initField('ram', 1)

		this.initField('disk', 0)
		this.initField('disk', 1)

		if (this.isCpuEmpty || this.isRamEmpty || this.isDiskEmpty)
		{
			this.showChoiceBlock()
		}
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// убираем обработчики событий
		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickDocumentHandler)

		this.deinitField('cpu', 0)
		this.deinitField('cpu', 1)

		this.deinitField('ram', 0)
		this.deinitField('ram', 1)

		this.deinitField('disk', 0)
		this.deinitField('disk', 1)
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация полей
		//---------------------------------------------------------------------
		initField(what, idx) {
			let name = what + idx
			if (!this.$refs[name]) return

			const $el = $(this.$refs[name])
			if (!$el || !$el.length) return

			$el.data('what', what)
			$el.data('idx', idx)
			$el.autoNumeric('init', { aSep: '', mDec: 0 })

			$el.off('change paste keyup').on('change paste keyup', (e) => {
				const $e = $(e.target)
				if (!$e || !$e.length) return

				const w = $e.data('what')
				const i = $e.data('idx')

				this.onInput(w, i, $e.autoNumeric('get'), $e)
			})
		},
		//---------------------------------------------------------------------
		// деинициализация полей
		//---------------------------------------------------------------------
		deinitField(what, idx) {
			let name = what + idx
			if (!this.$refs[name]) return

			const $el = $(this.$refs[name])
			if (!$el || !$el.length) return

			$el.off('change paste keyup')
			$el.autoNumeric('destroy')
		},
		//---------------------------------------------------------------------
		// обработчик нажатий клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие выбора метки
			if (e.keyCode === 27)
			{
				this.hideChoiceBlock()
			}
		},
		//---------------------------------------------------------------------
		// показ блока выбора
		//---------------------------------------------------------------------
		clickDocumentHandler(e) {
			if (!this.visible || !this.showChoicer) return

			if (!(this.$refs.choicer === e.target || this.$refs.choicer.contains(e.target)))
			{
				this.hideChoiceBlock()
			}
		},
		//---------------------------------------------------------------------
		// показ блока выбора
		//---------------------------------------------------------------------
		showChoiceBlock() {
			// cpu
			if (this.valueCpu[0] === null) Vue.set(this.sliderValueCpu, 0, parseInt(this.params.cpu_min.min, 10))
			else Vue.set(this.sliderValueCpu, 0, this.valueCpu[0])

			if (this.valueCpu[1] === null) Vue.set(this.sliderValueCpu, 1, parseInt(this.params.cpu_max.max, 10))
			else Vue.set(this.sliderValueCpu, 1, this.valueCpu[1])

			// ram
			if (this.valueRam[0] === null) Vue.set(this.sliderValueRam, 0, parseInt(this.params.ram_min.min, 10))
			else Vue.set(this.sliderValueRam, 0, this.valueRam[0])

			if (this.valueRam[1] === null) Vue.set(this.sliderValueRam, 1, parseInt(this.params.ram_max.max, 10))
			else Vue.set(this.sliderValueRam, 1, this.valueRam[1])

			// disk
			if (this.valueDisk[0] === null) Vue.set(this.sliderValueDisk, 0, parseInt(this.params.disk_min.min, 10))
			else Vue.set(this.sliderValueDisk, 0, this.valueDisk[0])

			if (this.valueDisk[1] === null) Vue.set(this.sliderValueDisk, 1, parseInt(this.params.disk_max.max, 10))
			else Vue.set(this.sliderValueDisk, 1, this.valueDisk[1])

			// show
			this.showChoicer = true
		},
		//---------------------------------------------------------------------
		// звкрытие выбора
		//---------------------------------------------------------------------
		hideChoiceBlock() {
			this.showChoicer = false

			this.$nextTick(() => {
				if (this.isCpuEmpty || this.isRamEmpty || this.isDiskEmpty)
				{
					this.$emit('closeDirectlyFilter')
				}
			})
		},
		//---------------------------------------------------------------------
		// подтверждение выбора
		//---------------------------------------------------------------------
		submit() {
			// закрываем блок выбора
			this.hideChoiceBlock()

			// копируем значения
			Vue.set(this.valueCpu, 0, this.sliderValueCpu[0])
			Vue.set(this.valueCpu, 1, this.sliderValueCpu[1])

			Vue.set(this.valueRam, 0, this.sliderValueRam[0])
			Vue.set(this.valueRam, 1, this.sliderValueRam[1])

			Vue.set(this.valueDisk, 0, this.sliderValueDisk[0])
			Vue.set(this.valueDisk, 1, this.sliderValueDisk[1])

			// сообщим родителям что значение поменялось
			this.$emit('input', {
				cpu_min: this.valueCpu[0],
				cpu_max: this.valueCpu[1],
				ram_min: this.valueRam[0],
				ram_max: this.valueRam[1],
				disk_min: this.valueDisk[0],
				disk_max: this.valueDisk[1]
			})
		},

		//---------------------------------------------------------------------
		getFormValueLink(what) {
			if (what !== 'cpu' && what !== 'ram' && what !== 'disk') return null

			let fieldName = ''
			if (what === 'cpu') fieldName = 'sliderValueCpu'
			if (what === 'ram') fieldName = 'sliderValueRam'
			if (what === 'disk') fieldName = 'sliderValueDisk'

			return this[fieldName]
		},

		//---------------------------------------------------------------------
		onBlur(what, idx) {
			let name = what + idx
			if (!this.$refs[name]) return
			this.$refs[name].value = this.getFormValueLink(what)[idx]
		},

		//---------------------------------------------------------------------
		onInput(what, idx, value, $el) {
			if (!what)
			{
				return
			}

			let _minParam = this.params[what + '_min']
			let _maxParam = this.params[what + '_max']
			if (!_minParam || !_minParam.title ||
				!_maxParam || !_maxParam.title)
			{
				return
			}

			let _link = this.getFormValueLink(what)
			if (!_link) return

			let _min = _minParam.min
			let _max = _maxParam.max

			let _value = parseInt(value, 10)
			if (isNaN(_value) || _value < _min) _value = _min
			if (_value > _max) _value = _max

			if (idx === 0 && _value > _link[1]) _value = _link[1]
			if (idx === 1 && _value < _link[0]) _value = _link[0]

			_link[idx] = _value

			let _slider = this.$refs['slider_' + what]
			if (_slider && _slider.setValue)
			{
				_slider.setValue(_link)
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатели
	//=========================================================================
	watch: {
		'value': function() {
			this.valueCpu = [this.value.cpu_min, this.value.cpu_max]
			this.valueRam = [this.value.ram_min, this.value.ram_max]
			this.valueDisk = [this.value.disk_min, this.value.disk_max]
		},

		visible(value) {
			if (!value) this.showChoicer = false
			else
			{
				if (this.isCpuEmpty || this.isRamEmpty || this.isDiskEmpty)
				{
					this.showChoiceBlock()
				}
			}
		}
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		VueSlider,
		numberInput
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
div.widget-block {
	position: relative;
	padding: 15px 24px 15px 15px
}

.widget-filter-wrapper {
    font-weight: 300;
    line-height: 1.4;
}
.widget-filter-wrapper .item {
	display: inline-block;
	margin-right: 10px;
	cursor: pointer
}
.widget-filter-wrapper .param-title {
	font-weight: 400;
}
.widget-filter-wrapper .param-value {
	color: #333;
}

.widget-filter-choicer {
	position: absolute;
	top: 0;
	left: 0;

    border: 1px solid #ddd;
    background-color: #eee;
    border-radius: 4px;
    z-index: 900;

    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    -webkit-align-items: center;

    flex-direction: column;

    padding: 16px 8px;
}

.widget-filter-choicer > .title {
	font-size: 11px;
    font-weight: 500;
}

.widget-filter-choicer > .fields-block {
    display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-align: center;
    align-items: center;
    -webkit-align-items: center;
    width: 280px;
}

.widget-filter-choicer .field {
	flex: 0 0 50px;
}
.widget-filter-choicer .field > input {
	font-size: 12px;
	padding: 0 8px;
	width: 100%;
}

.widget-filter-choicer .slider {
	flex: 0 0 160px;
	position: relative;

	display: -ms-flexbox;
    display: flex;
    display: -webkit-flex;
    -ms-flex-pack: justify;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-align-items: center;

    padding: 0 16px;
}
.widget-filter-choicer .slider > .title {
	font-size: 10px;
	font-weight: 500;
}
.widget-filter-choicer .slider > .values {
	position: relative;
	font-size: 10px;
	font-weight: 300;
	top: -5px;
}
</style>



// WEBPACK FOOTER //
// filterParams.vue?1c3cc9f4